import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { AcademicPeriodData, AcademicPeriodNames } from '../../../interfaces/TranscriptsInterface';
import { ACADEMIC_PERIODS_NAMES } from '../../../constants';

import './SubjectAreaTable.css';

interface SubjectAreaTableProps {
  data: AcademicPeriodData[];
};

function SubjectAreaTable({ data }: SubjectAreaTableProps) {

  const getRowsCount = (studentData: AcademicPeriodData) => {
    let rowsCount = Math.max(...[studentData.NINTH_GRADE.length, studentData.TENTH_GRADE.length, studentData.ELEVENTH_GRADE.length, studentData.TWELFTH_GRADE.length]);
    return rowsCount;
  };

  const getRowClass = (rowIndex: number) => {
    return rowIndex % 2 !== 0 ? 'highlighted' : '';
  };

  return (
    <TableContainer>
      <Table className="subject-area-table">
        <TableHead>
          <TableRow>
            <TableCell className="subject-area-header-cell">Student</TableCell>
            <TableCell className="subject-area-header-cell">9th grade</TableCell>
            <TableCell className="subject-area-header-cell">10th grade</TableCell>
            <TableCell className="subject-area-header-cell">11th grade</TableCell>
            <TableCell className="subject-area-header-cell">12th grade</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((studentData, studentIndex) => {
            let rowCount = getRowsCount(studentData);
            if (rowCount === 0) {
              return (
                <TableRow key={studentIndex} className={`subject-area-table-row ${getRowClass(studentIndex)}`}>
                  <TableCell>Student {studentData.studentNumber}</TableCell>
                  <TableCell colSpan={4} className="subject-area-table-cell empty-row border-left">This student did not take any courses in this subject area</TableCell>
                </TableRow>
              );
            }
            let rows = [];
            for(let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
              if (rowIndex === 0) {
                rows.push(
                  <TableRow key={`${studentIndex}-${rowIndex}`} className={`subject-area-table-row ${getRowClass(studentIndex)}`}>
                    <TableCell rowSpan={rowCount}>Student {studentData.studentNumber}</TableCell>
                    <CoursesTableCells studentData={studentData} studentIndex={studentIndex} rowIndex={rowIndex} />
                  </TableRow>
                );
              } else {
                rows.push(
                  <TableRow key={`${studentIndex}-${rowIndex}`} className={`subject-area-table-row ${getRowClass(studentIndex)}`}>
                    <CoursesTableCells studentData={studentData} studentIndex={studentIndex} rowIndex={rowIndex} />
                  </TableRow>
                );
              }
            }

            return rows;
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

interface CoursesTableCellsProps {
  studentData: AcademicPeriodData;
  studentIndex: number;
  rowIndex: number;
}

function CoursesTableCells({ studentData, studentIndex, rowIndex }: CoursesTableCellsProps) {
  return (
    <>
      {(Object.keys(ACADEMIC_PERIODS_NAMES) as AcademicPeriodNames[]).map((academicPeriod, periodIndex) => (
        <TableCell key={`${studentIndex}-${rowIndex}-${periodIndex}`} className="subject-area-table-cell  border-left">
          {studentData[academicPeriod][rowIndex] ? 
            <div className="table-cell-content">
              <div className="course-info">
                <p>{studentData[academicPeriod][rowIndex].name}</p>
                <p>({studentData[academicPeriod][rowIndex].code})</p>
                <p>{studentData[academicPeriod][rowIndex].num_credits} credits</p>
              </div>
              <p className="course-grade">{studentData[academicPeriod][rowIndex].letter_grade || studentData[academicPeriod][rowIndex].number_grade}</p>
            </div>
            : 
            null
          }
        </TableCell>
      ))
      }
    </>
  );
};

export default SubjectAreaTable;